import { render, staticRenderFns } from "./aWorkDetailCopy.vue?vue&type=template&id=6cc3cc8c&scoped=true"
import script from "./aWorkDetailCopy.vue?vue&type=script&lang=js"
export * from "./aWorkDetailCopy.vue?vue&type=script&lang=js"
import style0 from "./aWorkDetailCopy.vue?vue&type=style&index=0&id=6cc3cc8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc3cc8c",
  null
  
)

export default component.exports